const dataURItoBlob = async(dataURI, fileName) => {
  const data = await fetch(`${dataURI}`)
  const blob = await data.blob()
  blob.name = fileName;
  blob.path = fileName;
  return blob
}

export {
  dataURItoBlob
}